import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    content_Module: "", content_Workbook: "", view_WorkbookName: "", dashboard_List: [], dashboard_URL_List: [], breadcrumb_URL: "",
};

const addContentSlice = createSlice({
    name: "addContent",
    initialState,
    reducers: {
        getMenuDataList: (state, action) => {
            const { selectedModule, workbookObject } = action.payload;
            const { view_workbook, workbook_title, SAN_TableauViews } = workbookObject;

            const dashboardDatas = SAN_TableauViews.map((datas) => ({ view_name: datas.view_title, view_portal_url: datas.view_portal_url, }));
            const sortedDashboardList = SAN_TableauViews.sort((a, b) => a.wb_view_order - b.wb_view_order).map(({ view_title }) => view_title);
            const breadcrumbURL = `${selectedModule}->${workbook_title}`;

            return {
                ...state, content_Module: selectedModule, content_Workbook: workbook_title, view_WorkbookName: view_workbook,
                dashboard_List: sortedDashboardList, dashboard_URL_List: dashboardDatas, breadcrumb_URL: breadcrumbURL
            };
        },

        resetDashboardState: (state) => {
            return { ...state, content_Module: "", content_Workbook: "", view_WorkbookName: "", dashboard_List: [], dashboard_URL_List: [], breadcrumb_URL: "" }
        }
    },
});

export const { getMenuDataList, resetDashboardState } = addContentSlice.actions;

export default addContentSlice.reducer;
